import React from "react";

export type ButtonV4Variant =
  "primary" | "ok" | "confirm" | "danger" | "ghost" | "danger-ghost" | "plain";

export type ButtonV4Size = "md" | "sm" | "icon";

type ButtonV4Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonV4Variant;
  size?: ButtonV4Size;
  pill?: boolean;
  selected?: boolean;
  // ข้อความยาวขึ้นบรรทัดใหม่
  wrap?: boolean;
};

/** ปุ่มของ HIS V4 (class hv4-btn ใน _hisv4-base.scss) */
const ButtonV4 = ({
  variant,
  size = "md",
  pill = false,
  selected = false,
  wrap = false,
  className,
  type = "button",
  ...props
}: ButtonV4Props) => {
  const classes = [
    "hv4-btn",
    variant && `hv4-btn-${variant}`,
    size !== "md" && `hv4-btn-${size}`,
    pill && "hv4-btn-pill",
    selected && "hv4-btn-selected",
    wrap && "hv4-btn-wrap",
    className,
  ];

  return <button type={type} className={classes.filter(Boolean).join(" ")} {...props} />;
};

export default ButtonV4;
